// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/navigation/Navbar.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$(),
  _s2 = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/navigation/Navbar.tsx");
  import.meta.hot.lastModified = "1773385375629.4705";
}
// REMIX HMR END

import { Popover } from "@headlessui/react";
import clsx from "clsx";
import { Fragment, useEffect } from "react";
import IconResolver from "~/components/IconResolver";
import Link from "~/components/Link";
import DropdownNav from "~/components/navigation/DropdownNav";
import { useScroll } from "~/utils/Hooks";
import Logo from "@assets/logo/logo.png";
import LogoHover from "@assets/logo/logo_hover.png";
import Button from "../Button";
import PromoBanner from "../PromoBanner";
import AccordionNav from "./AccordionNav";
export default function Navbar({
  navigation,
  information
}) {
  _s();
  const isScrolled = useScroll();
  return <Popover as="header" className={({
    open
  }) => clsx(open ? "inset-0 overflow-hidden" : "top-0", "fixed w-full z-40 md:overflow-y-visible")}>
      {({
      open,
      close
    }) => <Fragment>
          {/* NOTE: If this promobanner needs to be removed, we need to update some components to remove the extra spaced added to match the
           design specs, ParagraphHero, PageHeader */}
          {information?.promo_banner_flag === "1" && <PromoBanner>
              <span className="font-semibold" dangerouslySetInnerHTML={{
          __html: information.promo_banner_text || ""
        }} />
            </PromoBanner>}
          <nav className={clsx("w-full py-3 px-4 lg:px-24 transition-[background-color] ease-in-out duration-200", isScrolled ? "bg-primary-800 border-b border-b-primary-500" : "bg-transparent")}>
            <div className="relative flex items-center max-w-page mx-auto">
              <Link prefetch="intent" className="h-8 w-[131px] relative group" to="/">
                <img className="h-8 w-[130px] absolute opacity-100 transition-opacity ease-in-out duration-300 group-hover:opacity-0" src={Logo} alt="Octahedroid" />
                <img className="h-8 w-[130px] absolute opacity-0 group-hover:opacity-100 ease-in-out transition-opacity duration-300" src={LogoHover} alt="Octahedroid" />
              </Link>
              <div className="ml-auto flex items-center md:hidden">
                {/* Mobile menu button */}
                {navigation && navigation?.length > 0 && <Popover.Button className="ml-4 inline-flex items-center justify-center rounded-md text-neutral-500 hover:text-neutral-400 focus:outline-none">
                    {({
                open
              }) => <Fragment>
                        <span className="sr-only">Open menu</span>
                        <IconResolver token={open ? "x" : "menu"} className="w-8 h-8 text-neutral-200 hover:text-primary-200" />
                      </Fragment>}
                  </Popover.Button>}
              </div>
              <ul className="hidden md:flex ml-auto gap-6 lg:gap-10 items-center py-5" id="menu-primary-navigation">
                {navigation?.map(({
              route,
              title,
              expanded,
              children
            }, index, arr) => {
              const isLastItem = index + 1 === arr.length;
              if (isLastItem) {
                return <li key={title}>
                          <Button to={route?.url} variant="quaternary">
                            {title}
                          </Button>
                        </li>;
              }
              return <li key={title}>
                        {!expanded ? <Link theme="dark" title={title} prefetch="render" to={route?.url} underline>
                            {title}
                          </Link> : <DropdownNav title={title} items={children} />}
                      </li>;
            })}
              </ul>
            </div>
          </nav>

          <NavbarOverlay navigation={navigation} open={open} close={close} />
        </Fragment>}
    </Popover>;
}
_s(Navbar, "BSLo0DgZMOw9SXM5proX333FDL0=", false, function () {
  return [useScroll];
});
_c = Navbar;
function NavbarOverlay({
  navigation,
  open,
  close
}) {
  _s2();
  useEffect(() => {
    document.body.classList.toggle("overflow-hidden", open);
    document.body.classList.toggle("md:overflow-auto", open);
    return () => {
      document.body.classList.remove("overflow-hidden");
      document.body.classList.remove("md:overflow-auto");
    };
  }, [open]);
  return <Popover.Panel as="nav" className="md:hidden h-full bg-primary-800" aria-label="Mobile menu">
      <Popover.Group as="ul" id="mobile-menu-primary-navigation">
        {navigation?.map(({
        route,
        title,
        expanded,
        children
      }) => <li onClick={!expanded ? close : undefined} key={title} className="border-b border-primary-500">
            {!expanded ? <Link prefetch="render" title={title} to={route?.url} theme="dark" className="w-full block px-4 py-5">
                {title}
              </Link> : <AccordionNav title={title} items={children} closeNav={close} />}
          </li>)}
      </Popover.Group>
    </Popover.Panel>;
}
_s2(NavbarOverlay, "OD7bBpZva5O2jO+Puf00hKivP7c=");
_c2 = NavbarOverlay;
var _c, _c2;
$RefreshReg$(_c, "Navbar");
$RefreshReg$(_c2, "NavbarOverlay");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;